var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 84,
    viewBox: "0 0 115 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.5,
    cy: 59.5,
    rx: 35.5,
    ry: 2.5,
    fill: "#1C1C1C",
    fillOpacity: 0.767068
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 58,
    height: 59,
    rx: 10,
    fill: "url(#paint0_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 22.92H44.6V19.56H47.48C47.3467 19.3467 47.2133 19.0267 47.08 18.6C46.9467 18.1467 46.88 17.6133 46.88 17C46.88 16.12 47.0667 15.2933 47.44 14.52C47.84 13.7467 48.4133 13.08 49.16 12.52C49.9067 11.9333 50.8267 11.48 51.92 11.16C53.0133 10.8133 54.28 10.64 55.72 10.64C57.6667 10.64 59.4267 10.9467 61 11.56C62.5733 12.1467 63.9867 12.8933 65.24 13.8C66.4933 14.68 67.5867 15.6667 68.52 16.76C69.4533 17.8267 70.2667 18.84 70.96 19.8L71.28 20.32L68.2 22L67.76 21.32C67.12 20.4933 66.4 19.6533 65.6 18.8C64.8 17.9467 63.92 17.1733 62.96 16.48C62 15.7867 60.9467 15.2267 59.8 14.8C58.6533 14.3733 57.4133 14.16 56.08 14.16C54.4267 14.16 53.2133 14.52 52.44 15.24C51.6933 15.96 51.32 16.8267 51.32 17.84C51.32 18.5867 51.4133 19.16 51.6 19.56H55.72V22.92H52.32V45H48V22.92ZM69.1125 49.44C67.2725 49.3333 65.6058 49.04 64.1125 48.56C62.6458 48.08 61.3925 47.4267 60.3525 46.6C59.3125 45.8 58.5125 44.8533 57.9525 43.76C57.3925 42.64 57.1125 41.4 57.1125 40.04C57.1125 38.9467 57.3125 38.0133 57.7125 37.24C58.1125 36.44 58.5658 35.8133 59.0725 35.36C58.5925 34.8533 58.1125 34.24 57.6325 33.52C57.1525 32.7733 56.9125 31.88 56.9125 30.84C56.9125 30.0933 57.0458 29.4267 57.3125 28.84C57.6058 28.2533 57.9925 27.76 58.4725 27.36C58.9525 26.96 59.5125 26.6667 60.1525 26.48C60.7925 26.2667 61.4725 26.16 62.1925 26.16H67.3125V22.92H54.9125V19.56H75.9525V22.92H71.5925V29.52H63.8325C63.1125 29.52 62.5125 29.6533 62.0325 29.92C61.5525 30.1867 61.3125 30.6933 61.3125 31.44C61.3125 31.8933 61.3925 32.3067 61.5525 32.68C61.7392 33.0267 61.9392 33.32 62.1525 33.56C63.2992 33.0267 64.6325 32.76 66.1525 32.76C67.3525 32.76 68.4192 32.92 69.3525 33.24C70.3125 33.56 71.1258 34.0133 71.7925 34.6C72.4592 35.16 72.9658 35.84 73.3125 36.64C73.6858 37.4133 73.8725 38.28 73.8725 39.24C73.8725 40.12 73.6858 40.9467 73.3125 41.72C72.9658 42.4667 72.5792 43.0267 72.1525 43.4L68.7525 41.6C69.0458 41.3067 69.2725 40.9733 69.4325 40.6C69.6192 40.2267 69.7125 39.8133 69.7125 39.36C69.7125 38.5333 69.4192 37.8133 68.8325 37.2C68.2458 36.56 67.2858 36.24 65.9525 36.24C64.6192 36.24 63.5392 36.6 62.7125 37.32C61.9125 38.04 61.5125 38.9867 61.5125 40.16C61.5125 41.76 62.1925 43.0667 63.5525 44.08C64.9125 45.0933 67.0858 45.7467 70.0725 46.04L69.1125 49.44ZM69.0341 13.84C69.0341 13.2 69.2874 12.6133 69.7941 12.08C70.3007 11.52 70.9407 11.24 71.7141 11.24C72.5141 11.24 73.1541 11.52 73.6341 12.08C74.1141 12.6133 74.3541 13.2 74.3541 13.84C74.3541 14.56 74.1141 15.1867 73.6341 15.72C73.1274 16.2267 72.4874 16.48 71.7141 16.48C70.9407 16.48 70.3007 16.2267 69.7941 15.72C69.2874 15.1867 69.0341 14.56 69.0341 13.84Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 0.25,
    y: 35.25,
    width: 114.5,
    height: 48.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.875,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 32,
    y: 0,
    width: 60,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258229 0 0 0 0 0.495065 0 0 0 0 0.770833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 44.6,
    y: 10.64,
    width: 32.3525,
    height: 40.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 88.8774,
    y1: 0.951616,
    x2: 32.3534,
    y2: 56.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64FBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5383FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.3a30dcf7.svg";
export { ForwardRef as ReactComponent };